<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ mdiSortAscending }}</v-icon>
      </v-btn>
    </template>
    <v-list subheader>
      <v-subheader>
        {{ $t('eDocInternal.search.orderingProperty') }}
      </v-subheader>
      <v-list-item-group
        v-model="selectedItem"
        color="primary"
      >
        <v-list-item>
          <v-list-item-title>{{ $t('eDocInternal.search.ReceiveDate') }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>{{ $t('Outbox.Urgent') }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>{{ $t('eDocInternal.search.reply.deadlineDate') }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>

import { mdiSortAscending } from '@mdi/js'

export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      selectedItem: this.value,
      mdiSortAscending
    }
  },
  watch: {
    selectedItem: function (val) {
      if (val !== this.orderingProp) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
